import { useMemo } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { ErrorTypes } from 'feedback-public-submission-ui/constants/ErrorConstants';
import Selectors from 'feedback-public-submission-ui/constants/Selectors';
import { getErrorStateConfig } from 'feedback-public-submission-ui/utils/ErrorUtils';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorState = ({
  errorType = ErrorTypes.GENERIC,
  surfaceError = false
}) => {
  const {
    illustration,
    langKey
  } = useMemo(() => getErrorStateConfig(errorType), [errorType]);
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    "data-selenium-test": Selectors.ERROR,
    id: "errorMessage",
    illustration: illustration,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${langKey}.title`
    }),
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "ERROR_MESSAGE_LOADED",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${langKey}.line1`
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "100",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-selenium-test": `error-${errorType.toLowerCase()}`,
        message: `${langKey}.line2`
      })
    }), surfaceError && /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "100",
      as: "div",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "feedbackPublicUi.errorTitle"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `feedbackPublicUi.error.${errorType}.line1`
      })]
    })]
  });
};
export default ErrorState;